module.exports = __webpack_public_path__ + "static/Q1Answer2_Orange_LucasBenjamin-2bb01bc4653ee10e43051dcf2d1de74b.jpg";